import axios from 'axios'
import store from './store/index'
import router from './router'

axios.defaults.baseURL = process.env.NODE_ENV === 'production'
  ? 'https://api.liveabc.com/v1'
  : 'https://apitest.liveabc.com/v1'
axios.defaults.timeout = 40000

const excludedUrls = [
  '/login',
  '/check',
  '/barcode_check',
  '/product',
  '/products',
  '/register'
]

axios.interceptors.request.use(
  (request) => {
    const token = localStorage.getItem('authToken')

    if (token && !excludedUrls.includes(request.url)) {
      request.headers.common['Authorization'] = `Bearer ${token}`
    }

    axios.defaults.withCredentials = false

    return request
  },
  (error) => Promise.reject(error)
)

// axios.interceptors.response.use(
//   (response) => {
//     const { error } = response.data

//     if (error) {
//       console.log('API Error:', error)

//       switch (error) {
//         case 'Token not provided':
//           store.dispatch('logout')
//           router.push({ name: 'login' })
//           break
//         case 'TOKEN_EXPIRED':
//           store.dispatch('refreshToken')
//           break
//         case 'TOKEN_INVALID':
//           store.dispatch('logout')
//           router.push({ name: 'login' })
//           store.dispatch('updateAlert', {
//             isAlert: true,
//             isHead: true,
//             alertMsg: '登入資訊未更新',
//             type: 'alert'
//           })
//           break
//       }
//     }

//     return response
//   },
//   (error) => {
//     console.error('Axios Error:', error)

//     const { response, config, code, message } = error
//     const token = localStorage.getItem('authToken')

//     if (response) {
//       const { status } = response
//       store.commit('setErrorMessage', response)
//       if (status === 429) {
//         store.dispatch('updateAlert', {
//           isAlert: true,
//           isHead: true,
//           alertMsg: '系統忙碌中，請稍後再試',
//           type: 'alert'
//         })
//       }
//     } else {
//       store.commit('setErrorMessage', error.message)
//     }
//     if (
//       code === 'ECONNABORTED' &&
//       message.includes('timeout') &&
//       token &&
//       !config._retry
//     ) {
//       config._retry = true
//       return axios.request(config)
//     }

//     return Promise.reject(error)
//   }
// )
axios.interceptors.response.use(
  (response) => {
    const { error } = response.data

    if (error) {
      const url = response.config.url

      // 避免對 /logout 的回應再觸發 logout
      if (url === '/logout') return response

      switch (error) {
        case 'Token not provided':
          store.dispatch('logout')
          router.push({ name: 'login' })
          break
        case 'TOKEN_EXPIRED':
          store.dispatch('refreshToken')
          break
        case 'TOKEN_INVALID':
          store.dispatch('logout')
          router.push({ name: 'login' })
          break
      }
    }

    return response
  },
  (error) => {
    return Promise.reject(error)
  }
)
